import { TeamBuildingPage } from '@components/buzzkuri/pages/TeamBuilding'
import { useStaticPagesRes } from '@hook/useStaticPagesRes'
import { StaticPagesRes } from '@type/buzzkuri/static-page'
import { ErrorStatus } from '@type/common'
import { getDomain, getPagePropsReq } from '@utils/http'
import { GetServerSidePropsContext } from 'next'
import { ParsedUrlQuery } from 'querystring'
import {
  BusinessHead,
  OG_DEFAULT_IMAGE,
} from '@components/layouts/BusinessHead'

const TeamBuilding = (props: StaticPagesRes | ErrorStatus): JSX.Element => {
  const staticPagesRes = useStaticPagesRes(props)

  return (
    <>
      <BusinessHead
        noindex={false}
        title="チームビルディングとは"
        description="チームビルディングとは、複数のメンバーが同じ一つのゴールを目指し、チーム一丸となって進んでいけるような組織を作り上げていく取り組みのことです。 ビジネスの複雑化やIT化による企業を取り巻く環境が大きく変化するなか、組織の成果を最大化するための方法として多くの企業が注目し、導入を進めています。"
        openGraph={{
          url: `https://${getDomain}/team-building`,
          images: [OG_DEFAULT_IMAGE],
        }}
      />
      <TeamBuildingPage {...staticPagesRes} />
    </>
  )
}

export default TeamBuilding

export async function getServerSideProps(
  context: GetServerSidePropsContext<ParsedUrlQuery>
): Promise<{ props: StaticPagesRes | ErrorStatus }> {
  return getPagePropsReq(
    context,
    '/api/static_pages',
    '',
    false,
    'POST'
  ) as Promise<{
    props: StaticPagesRes | ErrorStatus
  }>
}
